<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const isFullScreen = computed(() => store.state.isFullScreen)
</script>

<template>
  <!-- The page's <main> landmark and the skip link's target (App.vue). Every
       routed view renders exactly one MainSection, so the id is unique. It
       carries no tabindex of its own: the skip link adds one while focusing
       it, so a click inside the page never focuses the whole region. -->
  <main
    id="main-content"
    class="px-4 sm:px-6 lg:px-8 w-full mx-auto max-w-[1600px] focus:outline-none"
    :class="[ isFullScreen ? 'flex h-screen items-center justify-center' : 'py-6 md:py-8' ]"
  >
    <slot />
  </main>
</template>
